export const TECHDOCS_REF_ANNOTATION = 'backstage.io/techdocs-ref';
